import React, { useEffect, useState, useRef } from "react";
import { Col, Row, Table } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import PdfHeader from "../layout/common/PdfHeader";
import { Button } from "react-bootstrap";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
import zIndex from "@mui/material/styles/zIndex";
import moment from "moment";

import { usePermissions } from "../contexts/PermissionContext";

const Result = ({ classId, studentrecords, admissionId }) => {


   const { userInfo } = usePermissions();


   console.log("userInfo0000000", userInfo);
  const [studentData, setStudentData] = useState(null);
  const [smarks, setMarks] = useState([]);
  const [subjectArray, setSubjectArray] = useState([]);
  const [settingexam, setsetting] = useState([]);
  const resultRef = useRef(); // Ref to access the content for PDF
  const fetchStudentResult = async (classId, admissionId) => {
    try {
      const result = await schoolApi.getStudentResult(classId, admissionId);

      if (result.success) {
        let studentRecord = {
          studentname: result?.results?.student_result.studentname,
          classname: result?.results?.student_result.classname,
          dateofbirth: result?.results?.student_result.dateofbirth,
          fathername: result?.results?.student_result.fathername,
          mothername: result?.results?.student_result.mothername,
          guardianname: result?.results?.student_result.guardianname,
          registration_no: result?.results?.student_result.registration_no,
          parentPhone: result?.results?.student_result.parentPhone,
        };

        setStudentData(studentRecord);
        const subjects = [];

        const resArr = result?.results?.student_result?.result;

        result?.results?.student_result?.result?.map((rs) => {
          if (!subjects.some((sub) => sub.label === rs.subject_id)) {
            subjects.push({ label: rs.subject_id, value: rs.subject });
          }
        });

        const groupedData = {};

        for (const record of resArr) {
          const { exam_type } = record;
          if (!groupedData[exam_type]) {
            groupedData[exam_type] = [];
          }
          groupedData[exam_type].push(record);
        }

        const redddsult = Object.keys(groupedData).map((key) => ({
          exam_type: key,

          exams: groupedData[key],
        }));

        setSubjectArray(subjects);
        setMarks(redddsult);
      } else {
      }
    } catch (error) {}
  };

  useEffect(() => {
    gradeSetting(); //added by muskan khan
    if (classId && admissionId) {
      fetchStudentResult(classId, admissionId);
    }
  }, [classId, admissionId]);

  const calculateTotals = () => {
    const totals = (smarks || []).reduce(
      (acc, group) => {
        const groupTotals = (group.exams || []).reduce(
          (groupAcc, exam) => {
            groupAcc.totalMarks += exam.max_marks || 0;
            groupAcc.obtainedMarks += exam.marks_obtained || 0;
            return groupAcc;
          },
          { totalMarks: 0, obtainedMarks: 0 }
        );
        acc.totalMarks += groupTotals.totalMarks;
        acc.obtainedMarks += groupTotals.obtainedMarks;
        return acc;
      },
      { totalMarks: 0, obtainedMarks: 0 }
    );

    const percentage =
      totals.totalMarks > 0
        ? (totals.obtainedMarks / totals.totalMarks) * 100
        : 0;

    const grade = (() => {
      if (percentage >= 90) return "A+";
      if (percentage >= 80) return "A";
      if (percentage >= 70) return "B+";
      if (percentage >= 60) return "B";
      if (percentage >= 50) return "C";
      return "F"; // Fail
    })();

    const division = (() => {
      if (percentage >= 60) return "First Division";
      else if (percentage >= 46 && percentage <= 59) return "Second Division";
      else if (percentage >= 33 && percentage <= 45) return "Third Division";
      else return "Fail";
    })();

    return { ...totals, percentage, grade, division };
  };

  const { totalMarks, obtainedMarks, percentage, grade, division } =
    calculateTotals();

  const gradeSetting = async () => {
    const result = await schoolApi.getAllSetting();
    console.log("result etting==>", result);
    try {
      if (result.success) {
        setsetting(result.data);
      }
    } catch (err) {
      console.error("Error", err);
    }
  };
  // const saveAsPdf = () => {
  //   console.log("calls");

  //   const doc = new jsPDF("p", "mm", "a4"); // 'p' for portrait, 'mm' for millimeters, 'a4' paper size

  //   doc.html(resultRef.current, {
  //     callback: (doc) => {
  //       doc.save("student_result.pdf");
  //     },
  //     margin: [10, 10, 10, 10], // Adjust margins as needed
  //     x: 10, // Horizontal offset
  //     y: 10, // Vertical offset
  //     html2canvas: {
  //       scale: 4, // Scale for better image quality
  //     },
  //     jsPDF: {
  //       unit: "mm", // Unit for measurements
  //       format: "a4", // A4 paper size
  //     },
  //   });
  // };
  const handleDownload = async () => {
    const input = document.getElementById("reportContent");
    console.log("input", input);

    const canvas = await html2canvas(input, { scale: 2, allowTaint: true });
    console.log(canvas);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("l", "mm", "a4");
    console.log("imgData", imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth() - 20;
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    const imgProps = pdf.getImageProperties(imgData);
    const imgWidth = pdfWidth;
    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

    let heightLeft = imgHeight;
    let position = 10;

    while (heightLeft > 0) {
      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      heightLeft -= pdf.internal.pageSize.getHeight();
      if (heightLeft > 0) {
        pdf.addPage();
        position = 0;
      }
    }

    pdf.save("StudentResult.pdf");
  };
  
  return (
    <>
      <Button
        onClick={handleDownload}
        className="ml-auto me-5 d-flex "
        style={{ zIndex: "300" }}
      >
        <i className="fa fa-download"></i>
      </Button>
      <div id="reportContent">
        {studentData ? (
          <>
            <Row>
              <PdfHeader />
            </Row>
            <Row className="m-0">
              <Col lg={12} className="p-0">
                <h4
                  className="m-0"
                  style={{
                    fontWeight: "700",
                    textAlign: "center",
                    color: "white",
                    backgroundColor: "#de8989",
                    padding: "5px 0px",
                    textTransform: "uppercase",
                    fontFamily: "sans-serif",
                  }}
                >
                  Student
                  <sup> ' </sup>s Profile
                </h4>
              </Col>

              {/* {studentData ? (
                <section className="studentProfile my-3">
                  <Col lg={4} className="p-0">
                    <Row className="m-0">
                      <Col lg={1}></Col>
                      <Col lg={4}>Name</Col>
                      <Col lg={1} className="p-0">
                        :
                      </Col>
                      <Col lg={5} className="ps-0">
                        {studentData.studentname}
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col lg={1}></Col>
                      <Col lg={4}>Mother's Name</Col>
                      <Col lg={1} className="p-0">
                        :
                      </Col>
                      <Col lg={5} className="ps-0">
                        {studentData.mothername}
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col lg={1}></Col>
                      <Col lg={4}>Class Name</Col>
                      <Col lg={1} className="p-0">
                        :
                      </Col>
                      <Col lg={5} className="ps-0">
                        {studentData.classname}
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col lg={1}></Col>
                      <Col lg={4}>DOB</Col>
                      <Col lg={1} className="p-0">
                        :
                      </Col>
                      <Col lg={5} className="ps-0">
                        {moment(studentData.dateofbirth).format("MM/DD/YYYY")}
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={4} className="p-0">
                    <Row className="m-0">
                      <Col lg={1}></Col>
                      <Col lg={4}>Father's Name</Col>
                      <Col lg={1} className="p-0">
                        :
                      </Col>
                      <Col lg={5} className="ps-0">
                        {studentData.fathername}
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col lg={1}></Col>
                      <Col lg={4}>Mobile</Col>
                      <Col lg={1} className="p-0">
                        :
                      </Col>
                      <Col lg={5} className="ps-0">
                        {studentData.parentPhone}
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col lg={1}></Col>
                      <Col lg={4}>Registration no</Col>
                      <Col lg={1} className="p-0">
                        :
                      </Col>
                      <Col lg={5} className="ps-0">
                        {studentData.registration_no}
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={4} className="student-image">
                    {studentrecords.file_parent_id && studentrecords.file_id ? (
                      <img
                        src={`/uploads/${studentrecords.file_parent_id}/${studentrecords.file_id}.${studentrecords.file_type}`}
                        alt="profile"
                        className="student-profile-picture"
                      />
                    ) : (
                      <img
                        src={`/uploads/dwps_ajmer/image_2024102442318.png`}
                        alt="dummy_profile"
                        height={100}
                      />
                    )}
                  </Col>
                </section>
              ) : (
                "Please Wait"
              )} */}
              {studentData ? (
                <section className="studentProfile my-3">
                  <Col lg={4} className="p-0">
                    <Row className="m-0">
                      <Col lg={1}></Col>
                      <Col lg={4}>Name</Col>
                      <Col lg={1} className="p-0">
                        :
                      </Col>
                      <Col lg={5} className="ps-0">
                        {studentData.studentname}
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col lg={1}></Col>
                      <Col lg={4}>Class Name</Col>
                      <Col lg={1} className="p-0">
                        :
                      </Col>
                      <Col lg={5} className="ps-0">
                        {studentData.classname}
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col lg={1}></Col>
                      <Col lg={4}>DOB</Col>
                      <Col lg={1} className="p-0">
                        :
                      </Col>
                      <Col lg={5} className="ps-0">
                        {moment(studentData.dateofbirth).format("MM/DD/YYYY")}
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col lg={1}></Col>
                      <Col lg={4}>Registration no</Col>
                      <Col lg={1} className="p-0">
                        :
                      </Col>
                      <Col lg={5} className="ps-0">
                        {studentData.registration_no}
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={4} className="p-0">
                  {studentData?.fathername !==' ' && (
                    <Row className="m-0">
                    <Col lg={1}></Col>
                    <Col lg={4}>Father's Name</Col>
                    <Col lg={1} className="p-0">
                      :
                    </Col>
                    <Col lg={5} className="ps-0">
                      {studentData?.fathername}
                    </Col>
                  </Row>
                  )}
                    {studentData.mothername !==' ' && (
                    <Row className="m-0">
                    <Col lg={1}></Col>
                    <Col lg={4}>Mother's Name</Col>
                    <Col lg={1} className="p-0">
                      :
                    </Col>
                    <Col lg={5} className="ps-0">
                      {studentData?.mothername}
                    </Col>
                  </Row>
                  )}
                    {studentData?.fathername ===' ' && studentData?.mothername ===' ' && (
                    <Row className="m-0">
                    <Col lg={1}></Col>
                    <Col lg={4}>Guardian's Name</Col>
                    <Col lg={1} className="p-0">
                      :
                    </Col>
                    <Col lg={5} className="ps-0">
                      {studentData?.guardianname}
                    </Col>
                  </Row>
                  )}
                    <Row className="m-0">
                      <Col lg={1}></Col>
                      <Col lg={4}>Mobile</Col>
                      <Col lg={1} className="p-0">
                        :
                      </Col>
                      <Col lg={5} className="ps-0">
                        {studentData.parentPhone}
                      </Col>
                    </Row>
                   
                  </Col>
                  <Col lg={4} className="student-image">
                    {studentrecords.file_parent_id && studentrecords.file_id ? (
                      <img
                        src={`/uploads/${userInfo.tenantcode}/${studentrecords.file_parent_id}/${studentrecords.file_id}.${studentrecords.file_type}`}
                        alt="profile"
                        className="student-profile-picture"
                      />
                    ) : (
                      <img
                        src={`/uploads/dwps_ajmer/image_2024102442318.png`}
                        alt="dummy_profile"
                        height={100}
                      />
                    )}
                  </Col>
                </section>
              ) : (
                "Please Wait"
              )}
            </Row>

            <Row className="m-0">
              {smarks?.length ? (
                <Col lg={12} className="p-0">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th
                          style={{
                            textAlign: "center",
                            fontFamily: "arial",
                            fontVariantCaps: "all-small-caps",
                            fontSize: "14px",
                          }}
                        >
                          Exam Type
                        </th>
                        {smarks.map((test, index) => (
                          <React.Fragment key={index}>
                            <th
                              colSpan="3"
                              style={{
                                textAlign: "center",
                                fontFamily: "arial",
                                fontVariantCaps: "all-small-caps",
                                fontSize: "14px",
                              }}
                            >
                              {test.exam_type}
                            </th>
                          </React.Fragment>
                        ))}
                      </tr>
                      <tr>
                        <th
                          style={{
                            textAlign: "center",
                            fontFamily: "arial",
                            fontVariantCaps: "all-small-caps",
                            fontSize: "14px",
                          }}
                        >
                          Subject
                        </th>
                        {smarks.map((test, index) => (
                          <React.Fragment key={index}>
                            <th style={{ textAlign: "center" }}>Max</th>
                            <th style={{ textAlign: "center" }}>Min</th>
                            <th style={{ textAlign: "center" }}>
                              Obtained Marks
                            </th>
                          </React.Fragment>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {subjectArray.map((subjectName) => {
                        return (
                          <tr key={subjectName.value}>
                            <td>
                              <strong>{subjectName.value}</strong>
                            </td>
                            {smarks.map((test) => {
                              const subjectExam = test.exams.find(
                                (exam) => exam.subject === subjectName.value
                              );
                              const min = subjectExam?.min_marks || 0;
                              const totalMarks = subjectExam?.max_marks || 0;
                              const obtainedMarks =
                                subjectExam?.marks_obtained || 0;

                              return (
                                <React.Fragment key={test.exam_type}>
                                  <td style={{ textAlign: "right" }}>
                                    {totalMarks}
                                  </td>
                                  <td style={{ textAlign: "right" }}>{min}</td>
                                  <td style={{ textAlign: "right" }}>
                                    {obtainedMarks}
                                  </td>
                                </React.Fragment>
                              );
                            })}
                          </tr>
                        );
                      })}

                      {smarks.length > 1 && (
                        <tr>
                          <td>
                            <strong>Result</strong>
                          </td>
                          {smarks.map((test, index) => {
                            const totalMarks = test.exams.reduce(
                              (sum, exam) => sum + (exam.max_marks || 0),
                              0
                            );
                            const obtainedMarks = test.exams.reduce(
                              (sum, exam) => sum + (exam.marks_obtained || 0),
                              0
                            );
                            // Calculate percentage
                            const percentage =
                              totalMarks > 0
                                ? (obtainedMarks / totalMarks) * 100
                                : 0;
                            let divisionn = "";
                            if (percentage >= 60) {
                              divisionn = "First Div";
                            } else if (percentage >= 45) {
                              divisionn = "Second Div";
                            } else if (percentage >= 33) {
                              divisionn = "Third Div";
                            } else {
                              divisionn = "Fail";
                            }
                            return (
                              <React.Fragment key={test.exam_type}>
                                <td style={{ textAlign: "left" }} colSpan="3">
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <strong>Total Marks: </strong>
                                    {totalMarks}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <strong>Obtained Marks: </strong>
                                    {obtainedMarks}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <strong>Division: </strong>
                                    {divisionn}
                                  </div>
                                  {settingexam.map((item) => {
                                    if (item.key === "result_mode") {
                                      if (item.value === "grade") {
                                        return (
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <strong>Grade: </strong>
                                            {grade}
                                          </div>
                                        );
                                      } else if (item.value === "percentage") {
                                        return (
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <strong>Percentage: </strong>
                                            {percentage.toFixed(2)}%
                                          </div>
                                        );
                                      }
                                    }
                                    return null;
                                  })}
                                </td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      )}

                      <tr>
                        <td>
                          <strong>Overall Result</strong>
                        </td>
                        <td colSpan={smarks.length * 3}>
                          {(() => {
                            const totalMarks = smarks.reduce(
                              (sum, test) =>
                                sum +
                                test.exams.reduce(
                                  (subSum, exam) =>
                                    subSum + (exam.max_marks || 0),
                                  0
                                ),
                              0
                            );
                            const obtainedMarks = smarks.reduce(
                              (sum, test) =>
                                sum +
                                test.exams.reduce(
                                  (subSum, exam) =>
                                    subSum + (exam.marks_obtained || 0),
                                  0
                                ),
                              0
                            );
                            const percentage =
                              totalMarks > 0
                                ? (obtainedMarks / totalMarks) * 100
                                : 0;
                            const division =
                              percentage >= 60
                                ? "First"
                                : percentage >= 46 && percentage <= 59
                                ? "Second"
                                : percentage >= 33 && percentage <= 45
                                ? "Third"
                                : "Fail";
                            console.log("division-->>", division);

                            const grade =
                              percentage >= 90
                                ? "A+"
                                : percentage >= 80
                                ? "A"
                                : percentage >= 70
                                ? "B+"
                                : percentage >= 60
                                ? "B"
                                : percentage >= 50
                                ? "C"
                                : percentage >= 40
                                ? "D"
                                : "E";

                            return (
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <strong>Total Marks: </strong>
                                  {totalMarks}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <strong>Obtained Marks: </strong>
                                  {obtainedMarks}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <strong>Division: </strong>
                                  {division}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <strong>Grade: </strong>
                                  {grade}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <strong>Percentage: </strong>
                                  {percentage.toFixed(2)}%
                                </div>
                              </div>
                            );
                          })()}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              ) : (
                <div className="mx-2 border-0 text-center m-3 ">
                  No Records Found!!!
                </div>
              )}
            </Row>
          </>
        ) : (
          <div className="mx-2 border-0 text-center m-3 ">
            No Records Found!!!
          </div>
        )}
      </div>
    </>
  );
};
export default Result;
